// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".border[data-v-434f232e]:before {\n  content: \"\";\n  border-left: 2px solid var(--bs-gray-300);\n  height: 26px;\n  position: absolute;\n  -ms-flex-item-align: center;\n      align-self: center;\n  top: -26px;\n}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
